import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@fontsource/libre-baskerville/400.css";
import "@fontsource/libre-baskerville/700.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "./index.css";
import { runCookieAudit } from "./lib/cookie-audit";

// Auto-recover from stale chunk errors after a redeploy. When a cached
// index-*.js references hashed chunks no longer on the server, dynamic
// imports throw "Importing a module script failed" — reload once to refresh.
if (typeof window !== "undefined") {
  const RELOAD_KEY = "__cws_chunk_reload";
  const isChunkError = (msg: string) =>
    /Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module|ChunkLoadError/i.test(msg);
  const tryReload = (msg: string) => {
    if (!isChunkError(msg)) return;
    try {
      if (sessionStorage.getItem(RELOAD_KEY)) return;
      sessionStorage.setItem(RELOAD_KEY, "1");
      window.location.reload();
    } catch {}
  };
  window.addEventListener("error", (e) => tryReload(e?.message || ""));
  window.addEventListener("unhandledrejection", (e: PromiseRejectionEvent) =>
    tryReload(String(e?.reason?.message || e?.reason || "")),
  );
  // Clear the guard on a successful load so future stale chunks can recover too.
  window.addEventListener("load", () => {
    setTimeout(() => {
      try { sessionStorage.removeItem(RELOAD_KEY); } catch {}
    }, 5000);
  });
}

createRoot(document.getElementById("root")!).render(<App />);

// Opt-in audit (?cookieAudit=1)
if (typeof window !== "undefined") {
  setTimeout(() => runCookieAudit(), 1500);
}
